import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { setLocale } from '@link/metro-toei-pass/i18n';
import {
  LOCALE_LIST,
  DEFAULT_LOCALE
} from '@link/metro-toei-pass/constants/locale';

interface LocaleRouteProps {
  children: React.ReactNode;
}

const LocaleRoute: React.FC<LocaleRouteProps> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const currentLocale = pathSegments[0];

    if (!LOCALE_LIST.includes(currentLocale)) {
      navigate(`/${DEFAULT_LOCALE}${location.pathname}`, { replace: true });
      return;
    }

    setLocale(currentLocale);
  }, [location.pathname, navigate]);

  return <>{children}</>;
};

export default LocaleRoute;
